import { POPUPS_MAP } from '../../renderPopupBody';

const InsertDashboardMessages = operation => {
  switch (operation) {
    case POPUPS_MAP.INSERT_BEFORE:
    case POPUPS_MAP.INSERT_AFTER:
      return {
        title: 'Insert a new dashboard',
        description: 'Add a new dashboard to the current object dashboard set.'
      };
    case POPUPS_MAP.REPLACE:
      return {
        title: 'Replace dashboard',
        description: 'Substitute a dashboard with another one.'
      };
    default:
      return null;
  }
};
export default InsertDashboardMessages;
